<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="consolidacionesFinancieras"
	[displayWith]="displayConsolidacionFinanciera"
	[value]="selectedConsolidacionFinanciera"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
